import React, { Component } from "react";
import MainLayout from "../../../components/Layout/MainLayout";
import "./bieu-do.scss";
import BieuDo500 from "./BieuDo500";
import BieuDo5000 from "./Bieudo5000";
import BieuDo10000 from "./BieuDo10000";
export default class BieuDo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "500",
    };
  }

  handleChangeActiveTab(e) {
    this.setState({
      activeTab: e,
    });
  }

  render() {
    return (
      <MainLayout
        {...this.props}
        showProgressBar={this.state.showProgressBar}
        title={"Biểu đồ"}
      >
        <div className="page-with-card">
          <div className="card-custom">
            <div className="card-custom-header">
              <div
                className={
                  this.state.activeTab === "500"
                    ? "header-tab tab-left active"
                    : "header-tab tab-left"
                }
                onClick={() => {
                  this.handleChangeActiveTab("500");
                }}
              >
                Quy hoạch chi tiết 1/500
              </div>

              <div
                className={
                  this.state.activeTab === "5000"
                    ? "header-tab tab-center active"
                    : "header-tab tab-center"
                }
                onClick={() => {
                  this.handleChangeActiveTab("5000");
                }}
              >
                Quy hoạch phân khu 1/5000
              </div>

              <div
                className={
                  this.state.activeTab === "10000"
                    ? "header-tab tab-right active"
                    : "header-tab tab-right"
                }
                onClick={() => {
                  this.handleChangeActiveTab("10000");
                }}
              >
                Quy hoạch chung 1/10000
              </div>
            </div>

            <div className="card-custom-body">
              {this.state.activeTab === "500" ? <BieuDo500></BieuDo500> : null}
              {this.state.activeTab === "5000" ? (
                <BieuDo5000></BieuDo5000>
              ) : null}
              {this.state.activeTab === "10000" ? (
                <BieuDo10000></BieuDo10000>
              ) : null}
            </div>
          </div>
        </div>
      </MainLayout>
    );
  }
}
